import rawAxios from "axios";
import axios from "../axios";

export const search = async (searchTerm: string, signal?: AbortSignal) => {
  let cancelToken: any;
  if (signal) {
    const source = rawAxios.CancelToken.source();
    cancelToken = source.token;
    if (signal.aborted) {
      source.cancel("Canceled");
    } else {
      signal.addEventListener("abort", () => {
        source.cancel("Canceled");
      });
    }
  }

  return axios
    .get(`/json/search?q=${encodeURIComponent(searchTerm)}`, {
      signal,
      cancelToken,
    } as any)
    .then((res) => {
      if (res && res.data) {
        return res.data;
      }
      return [];
    })
    .catch((error) => {
      if (
        rawAxios.isCancel(error) ||
        error?.name === "AbortError" ||
        error?.name === "CanceledError" ||
        error?.message === "Canceled"
      ) {
        return [];
      }
      if (error instanceof Error) {
        throw error;
      } else {
        throw new Error(error);
      }
    });
};
